import { useForm } from "@inertiajs/react"
import type { FormEvent } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { track } from "@/lib/analytics"

export default function UrlImportForm() {
  const { data, setData, post, processing, errors, transform } = useForm({
    source_url: "",
    address: "Pending import",
    listing_type: "sale",
  })

  transform((d) => ({ listing: d }))

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    track("listing_imported")
    post("/dashboard/listings")
  }

  return (
    <form onSubmit={handleSubmit} className="mt-8">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center">
            <svg className="size-4 text-warm-grey/50" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418" />
            </svg>
          </div>
          <Input
            value={data.source_url}
            onChange={(e) => setData("source_url", e.target.value)}
            placeholder="https://www.rightmove.co.uk/properties/..."
            type="url"
            required
            className="h-12 pl-10 text-base"
          />
        </div>
        <Button
          type="submit"
          disabled={processing}
          className="h-12 px-6 bg-red text-white hover:bg-deep-red text-sm font-medium"
        >
          {processing ? (
            <span className="flex items-center gap-2">
              <svg className="size-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
              Importing
            </span>
          ) : (
            "Import"
          )}
        </Button>
      </div>
      {errors.source_url && (
        <p className="mt-2 text-left text-xs text-red">{errors.source_url}</p>
      )}
    </form>
  )
}
